module.exports = __webpack_public_path__ + "static/media/dsa_bible.c4822262.svg";